import { render, staticRenderFns } from "./restrict-action.vue?vue&type=template&id=8eed7908&scoped=true"
import script from "./restrict-action.vue?vue&type=script&lang=js"
export * from "./restrict-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eed7908",
  null
  
)

export default component.exports